// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"1f84bd48","430":"1f84bd48","464":"1f84bd48","787":"1f84bd48"}[chunkId] + ".chunk.css";
};